// Optimized Unsplash delivery: auto WebP/AVIF, width-constrained, compressed.
export const optImg = (url, w, q = 68) => `${url}&auto=format&w=${w}&q=${q}`;

export const imgSrcSet = (url, widths, q = 68) =>
  widths.map((w) => `${optImg(url, w, q)} ${w}w`).join(", ");
